
import { defineComponent, reactive, PropType, onBeforeMount } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// realisations
import { dispatcher } from '@/core/realisations/dispatcher.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'

// types
import {
    DispatcherDeliveryListOrderT,
    DispatcherDeliveryStatusT,
} from '@/core/types/dispatcher.types'
import { DataState } from '@/core/classes/DataState.class'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
        TheSelect,
    },
    props: {
        deliveryCurrent: {
            type: Object as PropType<DispatcherDeliveryListOrderT>,
        },
    },
    emits: ['cancel', 'changed'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            //
            new_date: null as string | null,
            statusCode: null as number | null,
        })

        const data_state = reactive({
            statuses: new DataState<DispatcherDeliveryStatusT>({}),
        })

        const state_form$ = useVuelidate(
            { new_date: { required }, statusCode: { required } },
            state
        )

        const changeDate = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                if (!props.deliveryCurrent) return

                state.is_loading = true
                await dispatcher.changeOrderDeliveryDate({
                    invoice_id: props.deliveryCurrent.invoice_id as number,
                    newDate: state.new_date as string,
                    statusCode: state.statusCode as number,
                    deliveryId: props.deliveryCurrent.id as number,
                })
                emit('changed')
            } catch (error: any) {
                if (error.length) {
                    notifications.notifyError({
                        error,
                        title: 'При переносе даты произошла ошибка',
                    })
                } else {
                    notifications.notify({
                        title: 'При переносе даты произошла ошибка',
                        type: 'danger',
                    })
                }
            } finally {
                state.is_loading = false
            }
        }

        const emitCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        // statuses

        const loadStatuses = async () => {
            try {
                data_state.statuses.is_loading = true

                const data = await dispatcher.getStatusesDelivery()
                if (data.data) {
                    data_state.statuses.list = data.data.filter((status) => status.id !== 16)
                }

                data_state.statuses.is_failed = false
                data_state.statuses.failure.error_state.is_cancel = false
            } catch (error) {
                data_state.statuses.failure.catchError(error)

                if (!data_state.statuses.failure.error_state.is_cancel) {
                    data_state.statuses.is_failed = true
                }
            } finally {
                if (!data_state.statuses.failure.error_state.is_cancel) {
                    data_state.statuses.is_loading = false
                }
            }
        }

        //

        onBeforeMount(() => {
            loadStatuses()
        })

        return {
            state,
            data_state,
            //
            state_form$,
            changeDate,
            emitCancel,
            loadStatuses,
        }
    },
})
